class HeaderManager {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
    this.handleResponsive();
    this.handleTopbarScroll();
    this.initMegaSliders();
  }

  bindEvents() {
    this.handleSearch();
    this.handleMobileMenu();
    this.handleDropdowns();
    this.handleAccountDropdown();
    this.handleOverlay();
  }

  handleSearch() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const overlay = document.querySelector('[data-header-overlay]');
    const panel = document.querySelector('[data-header-search-panel]');
    const searchClose = document.querySelector('[data-search-close]');
    const searchInput = document.querySelector('[data-search-input]');

    if (!searchToggle || !overlay || !panel) return;

    searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.openSearch();
    });

    if (searchClose) {
      searchClose.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeSearch();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('overlay--active')) {
        this.closeSearch();
      }
    });

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          this.closeSearch();
        }
      });
    }

    this.handleSearchTabs();
    this.handleLiveSearch();
  }

  openSearch() {
    const overlay = document.querySelector('[data-header-overlay]');
    const panel = document.querySelector('[data-header-search-panel]');
    const searchInput = document.querySelector('[data-search-input]');

    if (overlay) overlay.classList.add('overlay--active');
    if (panel) panel.classList.add('panel--active');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      if (searchInput) searchInput.focus();
    }, 300);
  }

  adjustSearchHeight() {
    const searchContent = document.querySelector('.header__search-content');
    if (!searchContent) return;

    let shopifyBlocksHeight = 0;

    const pbarWrapper = document.getElementById('PBarNextFrameWrapper');
    if (pbarWrapper) {
      const style = pbarWrapper.getAttribute('style');
      if (style && style.includes('30px')) {
        shopifyBlocksHeight += 25;
      } else if (style && style.includes('68px')) {
        shopifyBlocksHeight += 64;
      }
    }

    const shopifyBlocks = document.querySelectorAll('shopify-block, shopify-app-block');
    shopifyBlocks.forEach(block => {
      if (block !== pbarWrapper) {
        shopifyBlocksHeight += block.offsetHeight;
      }
    });

    const newHeight = `calc(100dvh - ${shopifyBlocksHeight}px)`;
    searchContent.style.height = newHeight;
    
    if (!CSS.supports('height', '100dvh')) {
      searchContent.style.height = `calc(100vh - ${shopifyBlocksHeight}px)`;
    }
    searchContent.style.height = newHeight;
  }

  closeSearch() {
    const overlay = document.querySelector('[data-header-overlay]');
    const panel = document.querySelector('[data-header-search-panel]');

    if (overlay) overlay.classList.remove('overlay--active');
    if (panel) panel.classList.remove('panel--active');
    document.body.style.overflow = '';
  }

  setupSearchHeightObserver() {
    if (this.searchHeightObserver) {
      this.searchHeightObserver.disconnect();
    }

    this.searchHeightObserver = new MutationObserver(() => {
      this.adjustSearchHeight();
    });

    const pbarWrapper = document.getElementById('PBarNextFrameWrapper');
    if (pbarWrapper) {
      this.searchHeightObserver.observe(pbarWrapper, {
        attributes: true,
        attributeFilter: ['style']
      });
    }

    const shopifyBlocks = document.querySelectorAll('shopify-block, shopify-app-block');
    shopifyBlocks.forEach(block => {
      this.searchHeightObserver.observe(block, {
        attributes: true,
        childList: true,
        subtree: true
      });
    });

    window.addEventListener('resize', () => this.adjustSearchHeight());
  }

  handleSearchTabs() {
    const tabs = document.querySelectorAll('[data-tab]');
    const tabContents = document.querySelectorAll('[data-tab-content]');

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        tabs.forEach(t => t.classList.remove('header__search-tab--active'));
        tab.classList.add('header__search-tab--active');

        const tabType = tab.dataset.tab;

        tabContents.forEach(content => {
          if (content.dataset.tabContent === tabType) {
            content.classList.add('header__search-tab-content--active');
          } else {
            content.classList.remove('header__search-tab-content--active');
          }
        });
      });
    });
  }

  handleLiveSearch() {
    const searchInput = document.querySelector('[data-search-input]');
    const resultsContainer = document.querySelector('[data-search-results]');
    const staticContainer = document.querySelector('[data-search-static]');
    let searchTimeout;

    if (!searchInput || !resultsContainer) return;

    searchInput.addEventListener('input', (e) => {
      clearTimeout(searchTimeout);
      const query = e.target.value.trim();

      if (query.length === 0) {
        this.showStaticContent();
        return;
      }

      if (query.length < 2) return;

      searchTimeout = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    });
  }

  showStaticContent() {
    const resultsContainer = document.querySelector('[data-search-results]');
    const staticContainer = document.querySelector('[data-search-static]');

    if (resultsContainer && staticContainer) {
      resultsContainer.classList.remove('header__search-results--active');
      staticContainer.classList.remove('header__search-static--hidden');
    }
  }

  showSearchResults() {
    const resultsContainer = document.querySelector('[data-search-results]');
    const staticContainer = document.querySelector('[data-search-static]');

    if (resultsContainer && staticContainer) {
      resultsContainer.classList.add('header__search-results--active');
      staticContainer.classList.add('header__search-static--hidden');
    }
  }

  async performSearch(query) {
    const resultsContainer = document.querySelector('[data-search-results]');
    if (!resultsContainer) return;

    this.showSearchResults();

    resultsContainer.innerHTML = '<div class="header__search-loader"><div class="header__search-spinner"></div></div>';

    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`);
      const data = await response.json();

      if (data.resources && data.resources.results && data.resources.results.products) {
        const visibleProducts = data.resources.results.products
          .filter((product) => !(product.tags || []).includes('bundle-only'))
          .slice(0, 6);
        this.displaySearchResults(visibleProducts);
      } else {
        resultsContainer.innerHTML = '<div class="header__search-empty"><p>Aucun produit trouvé</p></div>';
      }
    } catch (error) {
      console.error('Search error:', error);
      resultsContainer.innerHTML = '<div class="header__search-empty"><p>Erreur lors de la recherche</p></div>';
    }
  }

  formatPrice(price) {
    let priceStr = String(price);
    priceStr = priceStr.replace('.', ',');
    if (!priceStr.includes('€')) {
      priceStr += ' €';
    }
    return priceStr;
  }

  displaySearchResults(products) {
    const resultsContainer = document.querySelector('[data-search-results]');
    if (!resultsContainer || !products.length) return;

    const resultsHTML = products.map(product => {
      const formattedPrice = this.formatPrice(product.price || product.price_min || '');
      const productType = product.type || product.product_type || '';

      return `
        <a href="${product.url}" class="header__search-product">
          <div class="header__search-product-left">
            <img src="${product.image}" alt="${product.title}" class="header__search-product-image" loading="lazy">
            <div class="header__search-product-info">
              ${productType ? `<span class="header__search-product-type">${productType}</span>` : ''}
              <h4 class="header__search-product-title">${product.title}</h4>
              <div class="header__search-product-price">${formattedPrice}</div>
            </div>
          </div>
          <i data-lucide="arrow-right" class="header__search-product-arrow" width="20" height="20"></i>
        </a>
      `;
    }).join('');

    resultsContainer.innerHTML = resultsHTML;

    if (window.lucide) {
      window.lucide.createIcons();
    }
  }

  handleMobileMenu() {
    const mobileToggle = document.querySelector('[data-mobile-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileClose = document.querySelector('[data-mobile-close]');
    const overlay = document.querySelector('[data-header-overlay]');

    if (!mobileToggle || !mobileMenu) return;

    mobileToggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.openMobileMenu();
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeMobileMenu();
      });
    }

    const submenuToggles = document.querySelectorAll('[data-mobile-submenu-toggle]');
    submenuToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const parentItem = toggle.closest('.header__mobile-item');

        const allItems = document.querySelectorAll('.header__mobile-item--has-children');
        allItems.forEach(item => {
          if (item !== parentItem) {
            item.classList.remove('header__mobile-item--active');
          }
        });

        parentItem.classList.toggle('header__mobile-item--active');
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('header__mobile-menu--active')) {
        this.closeMobileMenu();
      }
    });
  }

  openMobileMenu() {
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileToggle = document.querySelector('[data-mobile-toggle]');
    const overlay = document.querySelector('[data-header-overlay]');

    mobileMenu.classList.add('header__mobile-menu--active');
    mobileToggle.classList.add('is-active');
    overlay.classList.add('overlay--active');
    document.body.style.overflow = 'hidden';
  }

  closeMobileMenu() {
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileToggle = document.querySelector('[data-mobile-toggle]');
    const overlay = document.querySelector('[data-header-overlay]');

    mobileMenu.classList.remove('header__mobile-menu--active');
    mobileToggle.classList.remove('is-active');
    overlay.classList.remove('overlay--active');
    document.body.style.overflow = '';
  }

  handleDropdowns() {
    const navItems = document.querySelectorAll('.header__nav-item--has-mega');

    navItems.forEach(item => {
      const dropdown = item.querySelector('.mega-menu');
      let timeoutId;

      if (!dropdown) return;

      item.addEventListener('mouseenter', () => {
        clearTimeout(timeoutId);
        dropdown.style.display = 'block';
        setTimeout(() => {
          dropdown.classList.add('mega-menu--active');
        }, 10);
      });

      item.addEventListener('mouseleave', () => {
        dropdown.classList.remove('mega-menu--active');
        timeoutId = setTimeout(() => {
          dropdown.style.display = 'none';
        }, 300);
      });
    });
  }

  handleAccountDropdown() {
    const accountToggle = document.querySelector('[data-account-toggle]');
    const accountMenu = document.querySelector('[data-account-menu]');

    if (!accountToggle || !accountMenu) return;

    accountToggle.addEventListener('click', (e) => {
      e.preventDefault();
      accountMenu.classList.toggle('is-open');
    });

    document.addEventListener('click', (e) => {
      if (!accountToggle.contains(e.target) && !accountMenu.contains(e.target)) {
        accountMenu.classList.remove('is-open');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        accountMenu.classList.remove('is-open');
      }
    });
  }

  handleOverlay() {
    const overlay = document.querySelector('[data-header-overlay]');
    
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.closeSearch();
        this.closeMobileMenu();
      });
    }
  }

  handleResponsive() {
    const mediaQuery = window.matchMedia('(min-width: 64rem)');

    const handleMediaChange = (e) => {
      if (e.matches) {
        this.closeMobileMenu();
        this.closeSearch();
      }
    };

    mediaQuery.addListener(handleMediaChange);
    handleMediaChange(mediaQuery);
  }

  handleTopbarScroll() {
    const topbar = document.querySelector('.header__topbar');
    if (!topbar) return;

    let lastScroll = 0;
    let ticking = false;

    const updateTopbar = () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll <= 0) {
        topbar.classList.remove('header__topbar--hidden');
      } else if (currentScroll > lastScroll) {
        topbar.classList.add('header__topbar--hidden');
      } else if (currentScroll < lastScroll) {
        topbar.classList.remove('header__topbar--hidden');
      }

      lastScroll = currentScroll;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateTopbar);
        ticking = true;
      }
    });
  }

  initMegaSliders() {
    this.initStorySliders();
  }

  initStorySliders() {
    const sliders = document.querySelectorAll('[data-story-slider]');

    sliders.forEach(slider => {
      const bars = slider.querySelectorAll('[data-story-bar]');
      const slides = slider.querySelectorAll('[data-story-slide]');
      const duration = 4000;
      let currentIndex = 0;
      let interval = null;
      let isHovered = false;

      const goToSlide = (index) => {
        bars.forEach((bar, i) => {
          bar.classList.remove('mega-menu__story-bar--active', 'mega-menu__story-bar--done');
          if (i < index) {
            bar.classList.add('mega-menu__story-bar--done');
          } else if (i === index) {
            bar.classList.add('mega-menu__story-bar--active');
          }
        });

        slides.forEach((slide, i) => {
          slide.classList.toggle('mega-menu__story-slide--active', i === index);
        });

        currentIndex = index;
      };

      const nextSlide = () => {
        if (isHovered) return;
        const next = (currentIndex + 1) % slides.length;
        goToSlide(next);
      };

      const startAutoplay = () => {
        if (interval) clearInterval(interval);
        interval = setInterval(nextSlide, duration);
      };

      const stopAutoplay = () => {
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
      };

      slider.addEventListener('mouseenter', () => {
        isHovered = true;
        stopAutoplay();
      });

      slider.addEventListener('mouseleave', () => {
        isHovered = false;
        startAutoplay();
      });

      bars.forEach((bar, index) => {
        bar.addEventListener('click', () => {
          goToSlide(index);
          stopAutoplay();
          startAutoplay();
        });
      });

      const megaMenu = slider.closest('.mega-menu');
      if (megaMenu) {
        const navItem = megaMenu.closest('.header__nav-item');
        if (navItem) {
          navItem.addEventListener('mouseenter', () => {
            goToSlide(0);
            setTimeout(() => startAutoplay(), 100);
          });
          navItem.addEventListener('mouseleave', () => {
            stopAutoplay();
            bars.forEach(bar => {
              bar.classList.remove('mega-menu__story-bar--active', 'mega-menu__story-bar--done');
            });
          });
        }
      }

      // Start on mega menu hover as backup
      megaMenu?.addEventListener('mouseenter', () => {
        if (!interval && !isHovered) {
          startAutoplay();
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeaderManager();
});

window.addEventListener('resize', () => {
  const header = new HeaderManager();
  header.closeMobileMenu();
  header.closeSearch();
});